import type { DashboardDto } from "@stryker/core/types/dashboard";
import DynamicTable from "@/components/dashboard/DynamicTable";
import { Typography } from "@/components/ui/typography";

type CostPieProps = {
  graphsData?: DashboardDto["costPieChart"];
};
export default function CostTables({ graphsData }: CostPieProps) {
  return (
    <div className="flex flex-col gap-8 p-4">
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Cost % by branch
        </Typography>
        <DynamicTable data={graphsData?.byBranch.map((v) => costCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Cost % by plant
        </Typography>
        <DynamicTable data={graphsData?.byPlant.map((v) => costCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Cost % by person
        </Typography>
        <DynamicTable data={graphsData?.byPerson.map((v) => costCountToPercentage(v)) ?? []} />
      </div>
      <div>
        <Typography variant="text-lg" className="font-semibold mb-2">
          Cost % by kit size
        </Typography>
        <DynamicTable
          data={
            graphsData?.byKitsSize.map((v) => {
              return costCountToPercentage(v);
            }) ?? []
          }
        />
      </div>
    </div>
  );
}

const costCountToPercentage = (v: any) => {
  return {
    ...v,
    cost: Number.parseFloat((v.cost * 100).toFixed(1)) + "%",
  };
};
